//import React from "react";
import 
    React
    , {
        useEffect
    } from 'react';
//import Hero from "./Hero";
//import ItemLoreBuilding from "../ItemLoreBuilding";
//import StartInvestingToday from "./StartInvestingToday";
//import Selection from "./Selection";
//import Popular from "./Popular";
//import HotBid from "../../components/HotBid";
//import Collections from "./Collections";
//import Discover from "./Discover";
//import Description from "./Description";
//import RecentSold from './RecentSold/index';
//import Banner from "./Banner";
//import MetaLondas from "./MetaLodons";
//import Teams from "./Teams";
//import ContactUs from "./ContactUs";
//import AuctionAssets from "./AuctionAssets";
import PastDealsCustomized from "./PastDealsCustomized";

/*
Dark background image = "linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)" />
Light background image = "linear-gradient(180deg, #000000 0%, #2C466B 100%)" />
*/

const Scratch = () => {
    console.log('Scratch()');

    useEffect(() => {
        //document.getElementsByTagName('body')[0].classList.add('');
        //document.getElementsByTagName('body')[0].classList.remove('search');
        document.getElementsByTagName('body')[0].className = '';
    }, null);

    return (
        <>

        <main>

        {/*
        <Hero />
        <ItemLoreBuilding />
        */}
        <PastDealsCustomized />

        {/*
        <Banner />
        <MetaLondas />
        <Teams />
        <ContactUs />
        */}

        {/* <Selection /> */}

        {/*
        <RecentSold
            color="#fff"
            textColor="#000"
            />
            
        <Popular
            textColor="#fff"
            backgroundImage="linear-gradient(180deg, #000000 0%, #2C466B 100%)"
            />

        <StartInvestingToday />

        <AuctionAssets
            textColor="#000"
            backgroundImage="linear-gradient(180deg, rgba(212, 222, 236, 0.3) 0%, rgba(217, 217, 217, 0) 100%)"
            />

        <HotBid classSection="section" />
        <Collections />
        <Discover />
        <Description />
        */}

        </main>

        </>
    );
};

export default Scratch;
